<template>
  <div class="background">
    <article class="leaderboard">
      <header>
        <h1 class="leaderboard__title"><span class="leaderboard__title--top">昨日排行榜</span><span class="leaderboard__title--bottom">Leaderboard</span></h1>
      </header>

      <div class="leaderboard__profiles">
        <article class="leaderboard__profile">
          <!--img src="https://www.jq22.com/tp/6372812585516618404071136.png" alt="Mark Zuckerberg" class="leaderboard__picture"-->
          <span class="leaderboard__name">Mark</span>
          <span class="leaderboard__value">109<span>A</span></span>
        </article>

        <article class="leaderboard__profile">
          <!--img src="https://www.jq22.com/tp/6372812586050993832639048.png" alt="Dustin Moskovitz" class="leaderboard__picture"-->
          <span class="leaderboard__name">勤奋人</span>
          <span class="leaderboard__value">101<span>B</span></span>
        </article>

        <article class="leaderboard__profile">
          <!--img src="https://www.jq22.com/tp/6372812586543183316035616.png" alt="Elizabeth Holmes" class="leaderboard__picture"-->
          <span class="leaderboard__name">。El主宰。</span>
          <span class="leaderboard__value">99<span>C</span></span>
        </article>

        <article class="leaderboard__profile">
          <!--img src="https://www.jq22.com/tp/6372812586954117362846160.png" alt="Evan Spiegel" class="leaderboard__picture"-->
          <span class="leaderboard__name">zzn</span>
          <span class="leaderboard__value">97<span>D</span></span>
        </article>
      </div>
    </article>
  </div>
</template>

<script>

  export default {
    name: 'Lists',
    data () {
      return {
        baseUrl: 'http://goc6.com',
        fromTime: new Date(new Date().toLocaleDateString()).getTime(),
        score : 100
      }
    },
    mounted () {
      this.inits();
    },
    methods: {
      inits (){

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  html, body { height: 100%; width: 100%;Font-size: 25%}
  body {
    margin: 0;
    background-color: #eaeaea;
    display: grid;
    height: 100vh;
    place-items: center;
    font-family: 'Source Sans Pro', sans-serif;
  }
  .background{
    /*background-image: url("https://t7.baidu.com/it/u=1297102096,3476971300&fm=193&f=GIF");*/
    height: 100%;
    width: 100%;
    background-size: cover;
    position: absolute;
  }
  .leaderboard {
    position: absolute;
    width: 90%;
    top: 10%;
    left: 5%;
    max-width: 490px;
    border-radius: 12px;
  }
  .leaderboard header {
    --start: 15%;
    height: 130px;
    background-image: repeating-radial-gradient(circle at var(--start), transparent 0%, transparent 10%, rgba(54, 89, 219, 0.33) 10%, rgba(54, 89, 219, 0.33) 17%), linear-gradient(to right, #5b7cfa, #3659db);
    color: #fff;
    position: relative;
    border-radius: 12px 12px 0 0;
    overflow: hidden;
  }
  .leaderboard header .leaderboard__title {
    position: absolute;
    z-index: 2;
    top: 50%;
    right: calc(var(--start) * .75);
    transform: translateY(-50%);
    text-transform: uppercase;
    margin: 0;
  }
  .leaderboard header .leaderboard__title span {
    display: block;
  }
  .leaderboard header .leaderboard__title--top {
    font-size: 24px;
    font-weight: 700;
    letter-spacing: 6.5px;
  }
  .leaderboard header .leaderboard__title--bottom {
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 3.55px;
    opacity: .65;
    transform: translateY(-2px);
  }
  .leaderboard header .leaderboard__icon {
    fill: #fff;
    opacity: .35;
    width: 50px;
    position: absolute;
    top: 50%;
    left: var(--start);
    transform: translate(-50%, -50%);
  }
  .leaderboard__profiles {
    background-color: #fff;
    border-radius: 0 0 12px 12px;
    padding: 15px 15px 20px;
    display: grid;
    row-gap: 8px;
  }
  .leaderboard__profile {
    display: grid;
    grid-template-columns: 1fr 3fr 1fr;
    align-items: center;
    padding: 10px 30px 10px 10px;
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 0 5px 7px -1px rgba(51, 51, 51, 0.23);
    cursor: pointer;
    transition: transform 0.25s cubic-bezier(0.7, 0.98, 0.86, 0.98), box-shadow 0.25s cubic-bezier(0.7, 0.98, 0.86, 0.98);
    background-color: #fff;
  }
  .leaderboard__profile:hover {
    transform: scale(1.2);
    box-shadow: 0 9px 47px 11px rgba(51, 51, 51, 0.18);
  }
  .leaderboard__picture {
    max-width: 100%;
    width: 60px;
    border-radius: 50%;
    box-shadow: 0 0 0 10px #ebeef3, 0 0 0 22px #f3f4f6;
  }
  .leaderboard__name {
    width: 100px;
    color: #979cb0;
    font-weight: 600;
    font-size: 20px;
    margin-left: 12px;
  }
  .leaderboard__value {
    color: #35d8ac;
    font-weight: 700;
    font-size: 34px;
    text-align: right;
  }
  .leaderboard__value > span {
    opacity: .8;
    font-weight: 600;
    font-size: 13px;
    margin-left: 3px;
  }



  .leaderboard {
    box-shadow: 0 0 40px -10px rgba(0, 0, 0, 0.4);
  }

</style>



// WEBPACK FOOTER //
// src/components/game/Lists.vue